import { createContext, useCallback, useState } from 'react';

interface IIPFSContext {
  ipfsClick: (clickedIPFS: string, clickedID: Number) => void;
  ipfs: string | null;
  tokenID: Number | null;
}

export const IPFSContext = createContext<IIPFSContext>({
  ipfsClick: (clickedIPFS: string, clickedID: Number) => {},
  ipfs: null,
  tokenID: 0
});

const IPFSProvider = ({ children }) => {

  const [ipfs, setIPFS] = useState<string | null>(null);
  const [tokenID, setTokenID] = useState<Number | null>(0);

  const ipfsClick = useCallback(async (clickedIPFS, clickedID) => {
   // console.log(clickedID);
    setIPFS(clickedIPFS);
    //console.log(clickedID);
    setTokenID(clickedID);
    console.log("clickedIDss =======> ", clickedID);
  }, []);


  return (
    <IPFSContext.Provider 
      value={{
        ipfsClick,
        ipfs,
        tokenID
      }}>
      {children}
    </IPFSContext.Provider>
  )
}

export default IPFSProvider;